<template>
  <div id="SignUp">
    <h2>ユーザー作成</h2>
    <hr>
    <div v-show="result">
      <div v-show="success">
        <p class="has-text-success">ユーザーの作成に成功しました！<br>ログインページよりログインしてください 🎉</p>
      </div>
      <div v-show="!success">
        <p class="has-text-danger">{{ errMsg }}</p>
      </div>
    </div>
    <div v-show="loading" class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-show="!loading && main">
      <section>
        <b-field horizontal label="メールアドレス">
          <b-input v-model.trim="email" type="email" maxlength="50"></b-input>
        </b-field>
        <b-field horizontal label="パスワード">
          <b-input v-model.trim="password" type="password" password-reveal></b-input>
        </b-field>
        <button class="button is-primary" v-on:click="exec()">ユーザー作成</button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUp',
  data: function () {
    return {
      main: true,
      loading: false,
      result: false,
      success: false,
      email: '',
      password: '',
      errMsg: ''
    }
  },
  methods: {
    exec: function () {
      this.$axios.post(this.baseURL + '/signup', {
        email: this.email,
        password: this.password
      }).then(() => {
        this.main = false
        this.result = true
        this.success = true
      }).catch((response) => {
        if (response.response.data === 'bind_json') {
          this.errMsg = '内部のエラーで登録できませんでした...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'encrypt') {
          this.errMsg = 'メールアドレスの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'hash') {
          this.errMsg = 'パスワードの暗号化に失敗しました...🙏 解決までしばらくお待ち下さい。'
        }
        if (response.response.data === 'already_registered') {
          this.errMsg = '入力されたメールアドレスは既に登録済みです 😃'
        }
        this.main = false
        this.result = true
        this.success = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue